import React from "react";
import {
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Divider,
  Collapse,
} from "@mui/material";
import { useState } from "react";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import PeopleIcon from "@mui/icons-material/People";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import PersonIcon from "@mui/icons-material/Person";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import DescriptionIcon from "@mui/icons-material/Description";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import BugReportIcon from '@mui/icons-material/BugReport';

const Sidebar = () => {
  const [openClientes, setOpenClientes] = useState(false);
  const [openCreditos, setOpenCreditos] = useState(false);
  const token = window.sessionStorage.getItem('localToken');
  const username = window.sessionStorage.getItem('username');
  let roleId = null;
  try {
    if (token) roleId = JSON.parse(atob(token.split('.')[1])).roleId;
  } catch (e) {
    roleId = null;
  }

  const handleClickClientes = () => {
    setOpenClientes(!openClientes);
  };

  const handleClickCreditos = () => {
    setOpenCreditos(!openCreditos);
  };

  return (
    <div
      className="sidebar"
      style={{ backgroundColor: "#cb1016bf", width: "100%", height: "100vh" }}
    >
      <List>
        {/* Clientes Dropdown */}
        <ListItem disablePadding>
          <ListItemButton 
            onClick={handleClickClientes}
            sx={{
              "&:hover": {
                border: "2px solid white",
                borderRadius: "4px"
              }
            }}
          >
            <PeopleIcon sx={{ color: "white", mr: 2 }} />
            <ListItemText 
              primary="Clientes" 
              sx={{ color: "white", fontSize: "14pt" }} 
            />
            {openClientes ? 
              <ExpandLess sx={{ color: "white" }} /> : 
              <ExpandMore sx={{ color: "white" }} />
            }
          </ListItemButton>
        </ListItem>
        <Collapse in={openClientes} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <ListItemButton 
              sx={{ 
                pl: 4,
                "&:hover": {
                  border: "2px solid white",
                  borderRadius: "4px"
                }
              }} 
              onClick={() => window.location.href = "/clients"}
            >
              <ListItemText 
                primary="Crear" 
                sx={{ color: "white" }} 
              />
            </ListItemButton>
            <ListItemButton 
              sx={{ 
                pl: 4,
                "&:hover": {
                  border: "2px solid white",
                  borderRadius: "4px"
                }
              }}
              onClick={() => window.location.href = "/search/clients"}
            >
              <ListItemText 
                primary="Consultar" 
                sx={{ color: "white" }} 
              />
            </ListItemButton>
          </List>
        </Collapse>
        <Divider sx={{ backgroundColor: "rgba(255,255,255,0.2)" }} />

        {/* Créditos Dropdown */}
        <ListItem disablePadding>
          <ListItemButton 
            onClick={handleClickCreditos}
            sx={{
              "&:hover": {
                border: "2px solid white",
                borderRadius: "4px"
              }
            }}
          >
            <AttachMoneyIcon sx={{ color: "white", mr: 2 }} />
            <ListItemText 
              primary="Créditos" 
              sx={{ color: "white", fontSize: "14pt" }} 
            />
            {openCreditos ? 
              <ExpandLess sx={{ color: "white" }} /> : 
              <ExpandMore sx={{ color: "white" }} />
            }
          </ListItemButton>
        </ListItem>
        <Collapse in={openCreditos} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <ListItemButton 
              sx={{ 
                pl: 4,
                "&:hover": {
                  border: "2px solid white",
                  borderRadius: "4px"
                }
              }}
              onClick={() => window.location.href = "/credits"}
            >
              <ListItemText primary="Crear" sx={{ color: "white" }} />
            </ListItemButton>
            <ListItemButton 
              sx={{ 
                pl: 4,
                "&:hover": {
                  border: "2px solid white",
                  borderRadius: "4px"
                }
              }}
              onClick={() => window.location.href = "/search/credits"}
            >
              <ListItemText primary="Consultar" sx={{ color: "white" }} />
            </ListItemButton>
          </List>
        </Collapse>
        <Divider sx={{ backgroundColor: "rgba(255,255,255,0.2)" }} />

        {/* Usuarios */}
        <ListItem disablePadding>
          <ListItemButton 
            onClick={() => window.location.href = "/users"}
            sx={{
              "&:hover": {
                border: "2px solid white",
                borderRadius: "4px"
              }
            }}
          >
            <PersonIcon sx={{ color: "white", mr: 2 }} />
            <ListItemText primary="Usuarios" sx={{ color: "white" }} />
          </ListItemButton>
        </ListItem>
        <Divider sx={{ backgroundColor: "rgba(255,255,255,0.2)" }} />

        {/* Valores UVR */}
        <ListItem disablePadding>
          <ListItemButton 
            onClick={() => window.location.href = "/uvr"}
            sx={{
              "&:hover": {
                border: "2px solid white",
                borderRadius: "4px"
              }
            }}
          >
            <TrendingUpIcon sx={{ color: "white", mr: 2 }} />
            <ListItemText primary="Valores UVR" sx={{ color: "white" }} />
          </ListItemButton>
        </ListItem>
        <Divider sx={{ backgroundColor: "rgba(255,255,255,0.2)" }} />

        {/* Informes */}
        <ListItem disablePadding>
          <ListItemButton 
            onClick={() => window.location.href = "/documents"}
            sx={{
              "&:hover": {
                border: "2px solid white",
                borderRadius: "4px"
              }
            }}
          >
            <DescriptionIcon sx={{ color: "white", mr: 2 }} />
            <ListItemText primary="Informes" sx={{ color: "white" }} />
          </ListItemButton>
        </ListItem>
        <Divider sx={{ backgroundColor: "rgba(255,255,255,0.2)" }} />

        {/* Cierre de periodo */}
        <ListItem disablePadding>
          <ListItemButton 
            onClick={() => window.location.href = "/closedPeriods"}
            sx={{
              "&:hover": {
                border: "2px solid white",
                borderRadius: "4px"
              }
            }}
          >
            <EventAvailableIcon sx={{ color: "white", mr: 2 }} />
            <ListItemText primary="Cierre de periodo" sx={{ color: "white" }} />
          </ListItemButton>
        </ListItem>
        <Divider sx={{ backgroundColor: "rgba(255,255,255,0.2)" }} />

        {/* Logs: sólo para admin complemento360 */}
        {roleId === 1 && username === 'complemento360' && (
          <>
            <ListItem disablePadding>
              <ListItemButton 
                onClick={() => window.location.href = "/logs"}
                sx={{
                  "&:hover": {
                    border: "2px solid white",
                    borderRadius: "4px"
                  }
                }}
              >
                <BugReportIcon sx={{ color: "white", mr: 2 }} />
                <ListItemText primary="Logs" sx={{ color: "white" }} />
              </ListItemButton>
            </ListItem>
            <Divider sx={{ backgroundColor: "rgba(255,255,255,0.2)" }} />
          </>
        )}
      </List>
    </div>
  );
};

export default Sidebar;